import React from 'react';
import cn from 'classnames';

import styles from './PlayButton.module.scss';

export interface PlayButtonProps {
  className: string;
}
// TODO: need to check the translation from POEditor for aria label
function PlayButton({ className }: PlayButtonProps) {
  return (
    <div role='button' aria-label='Play Button' data-type='playButton' className={cn(styles.playBtn, className)}>
      <span>&gt;</span>
    </div>
  );
}

export default PlayButton;
